export const defaultUserSettingsConstant = {
  userId: '',
  assetColumnsToDisplay: [],
  assetTableToDisplay: [],
  deviceColumnsToDisplay: [],
  deviceTableToDisplay: [],
  tagsToDisplay: [],
};